import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductList from "../../components/AdvanceDynamicList/ProductList";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
// import "./DynamicManagementPage.css";

const DynamicManagementPage = () => {
  const { key } = useParams(); // 🔑 Dynamic route param (e.g., user, vendor)
const config = getStoredData()?.[3]?.[key];
// console.log(config);

  const { Title = "Item", Fields = [], RedirectPath = "/", ApiPath = key } = config || {};

  const { apiData, loading, error } = useApiData([ApiPath]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (apiData?.[ApiPath] && Array.isArray(apiData[ApiPath])) {
      setItems(apiData[ApiPath]);
    } else {
      setItems([]);
    }
  }, [apiData, ApiPath]);

  if (!config) return <p>❌ Invalid module config for "{key}"</p>;
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="DynamicManagementPage">
      <h1>{Title} Management</h1>
      <ProductList
        products={items}
        fields={Fields}
        redirect={RedirectPath}
        deleteApi={ApiPath}
        showEdit={true}
        showDelete={true}
        createPath={`/${key}/create`}
        noDataMessage={`No ${Title.toLowerCase()}s found`}
      />
    </div>
  );
};

export default DynamicManagementPage;
